const isServer = typeof window === 'undefined';
const ua = isServer ? '' : (window.navigator.userAgent || '').toLowerCase();

export const isIOS = () => {
  if (isServer) {
    return false;
  }
  const navPlatform = window.navigator ? window.navigator.platform || '' : '';
  const navAgent = window.navigator ? window.navigator.userAgent || '' : '';
  return (
    /^(iPad|iPhone|iPod).*/.test(navPlatform) ||
    (navAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export const isWinOS = () => {
  if (isServer) {
    return false;
  }
  return (
    window.navigator.userAgent.indexOf('Win') !== -1 ||
    window.navigator.appVersion.indexOf('Win') !== -1
  );
};

export const isSafari = () => {
  var uaVal = ua.toLowerCase();
  return uaVal.indexOf('safari') > -1 && uaVal.indexOf('chrome') <= -1;
};

export const getWinWidth = (ssrWidth = 900) => {
  if (isServer) {
    return ssrWidth;
  }
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
};

export const getWinHeight = (ssrHeight = 900) => {
  if (isServer) {
    return ssrHeight;
  }
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
  );
};
